module.exports = __webpack_public_path__ + "img/tmx_warehouse2.7ae74d0d.jpg";